// components/CEOSection.jsx
import React from 'react'
import CEO from '../assets/team/CEO.png'
const CEOSection = () => {
    return (
        <div className="">
            <div className="flex flex-col gap-10 md:flex-row items-center justify-start">
                    <img 
                        src={CEO}
                        alt="CEO Name" 
                        className="w-1/4  object-cover border-4 border-white "
                    />
                <div className="">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-2">
                        Syed Aleem Haider
                    </h2>
                    <p className="text-xl text-indigo-600 font-semibold mb-4">
                        Chief Executive Officer
                    </p>
                    <p className="text-gray-600 leading-relaxed">
                        At DevSpots.us, we believe technology should not just solve problems — it should anticipate them.
Every line of code we write, every AI agent we build, and every platform we design is driven by one purpose: to create intelligence that empowers.
We’re not just developers; we’re enablers of the future — where businesses thrive through automation, and innovation becomes instinct.
Let’s build a world where your digital presence doesn’t just exist — it evolves.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default CEOSection